import { Component, inject } from '@angular/core';
import { SweetalertService } from '../../shared/services/sweetalert.service';
import { StoredAddressService } from '../../shared/services/api/stored-address.service';
import { CreateStoredAddressDto } from '../../../api/gen/api';


@Component({
  selector: 'app-dev',
  imports: [],
  templateUrl: './dev.component.html',
  styleUrl: './dev.component.scss',
})
export class DevComponent {
  sweetalertService = inject(SweetalertService);
  storedAddressService = inject(StoredAddressService);

  logs: string[] = [];

  ngOnInit() {
    this.log('Welcome to Admin Dashboard');
  }

  log(message: string) {
    this.logs.push(message);
    // Optionally keep max logs for performance
    if (this.logs.length > 100) {
      this.logs.shift();
    }
  }

  createStoredAddresses() {
    const cities = [
      'Vienna',
      'Salzburg',
      'Graz',
      'Innsbruck',
      'Linz',
      'Klagenfurt',
      'Villach',
      'Wels',
      'Sankt Pölten',
      'Dornbirn',
    ];
    const streets = [
      'Hauptstraße',
      'Bahnhofstraße',
      'Kirchplatz',
      'Ringstraße',
      'Dorfstraße',
      'Schulstraße',
      'Gartenweg',
      'Mozartgasse',
      'Bergstraße',
      'Mozartplatz',
    ];

    const taxiCenterId = '16ecb231-c721-45aa-8d4d-6398fa205107';

    for (let i = 1; i <= 100; i++) {
      const city = cities[i % cities.length];
      const street = streets[i % streets.length];
      const address: CreateStoredAddressDto = {
        city,
        countryCode: 'AT',
        houseNo: ((i % 100) + 1).toString(),
        name: `Massage Company ${i}`,
        postalCode: this.getPostalCodeForCity(city),
        street,
        taxiCenterId,
      };

      this.storedAddressService.addStoredAddress(address).subscribe({
        next: (response) => {
          this.log(response.name + ' added');
        },
        error: (error) => {
          console.error(error);
          this.log('ERROR: ' + error.message);
        },
      });
    }
  }

  // Helper function for postal codes (simplified)
  getPostalCodeForCity(city: string): string {
    const postalCodes: { [key: string]: string } = {
      Vienna: '1010',
      Salzburg: '5020',
      Graz: '8010',
      Innsbruck: '6020',
      Linz: '4020',
      Klagenfurt: '9020',
      Villach: '9500',
      Wels: '4600',
      'Sankt Pölten': '3100',
      Dornbirn: '6850',
    };
    return postalCodes[city] || '0000';
  }
}
